import { CheckCircle2, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { Button } from "../../components/ui/button";

// Success popup for associate/employee creation & verification steps.
export const SuccessDialog = ({ message, onClose, kind = "Associate", testid }) => {
  const [head, ...rest] = String(message || "").split(/(?<=\.)\s+/);
  return (
    <Dialog open={!!message} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-md overflow-hidden p-0" data-testid={testid}>
        <div className="h-1.5 w-full bg-gradient-to-r from-teal-700 via-emerald-500 to-teal-700" />
        <div className="flex flex-col items-center px-8 pb-7 pt-6 text-center">
          <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 ring-8 ring-emerald-50/60">
            <CheckCircle2 className="h-9 w-9 text-emerald-600" />
          </span>
          <span className="mb-1 text-[11px] font-semibold uppercase tracking-[0.18em] text-teal-700">{kind} · Success</span>
          <DialogTitle className="text-lg font-semibold leading-snug text-slate-900">{head}</DialogTitle>
          {rest.length > 0 && (
            <DialogDescription className="mt-3 w-full rounded-lg border border-emerald-100 bg-emerald-50/60 px-4 py-2.5 text-sm text-emerald-800">
              {rest.join(" ")}
            </DialogDescription>
          )}
          <Button className="mt-6 w-full bg-teal-700 text-white hover:bg-teal-800" onClick={onClose} data-testid={`${testid}-close`}>
            Done <ArrowRight className="ml-1.5 h-4 w-4" />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
